import { render, staticRenderFns } from "./ResultReferenceSettings.vue?vue&type=template&id=6602c9e0&scoped=true&"
import script from "./ResultReferenceSettings.vue?vue&type=script&lang=js&"
export * from "./ResultReferenceSettings.vue?vue&type=script&lang=js&"
import style0 from "./ResultReferenceSettings.vue?vue&type=style&index=0&id=6602c9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602c9e0",
  null
  
)

export default component.exports